import AddressEditable from './components/AddressEditable.vue'
import AddressReadonly from './components/AddressReadonly.vue'
import AGB from './components/AGB.vue'
import AjaxButton from './components/AjaxButton.vue'
import Checkbox from './components/Checkbox.vue'
import CheckboxList from './components/CheckboxList.vue'
import DatePickerWithLabel from './components/DatePickerWithLabel.vue'
import DSE from './components/DSE.vue'
import InfoIcon from './components/InfoIcon.vue'
import InputWithLabel from './components/InputWithLabel.vue'
import MigrosLoginInfo from './components/MigrosLoginInfo.vue'
import MyClimateCheckbox from './components/MyClimateCheckbox.vue'
import MyClimateDescription from './components/MyClimateDescription.vue'
import Pager from './components/Pager.vue'
import Radiobutton from './components/Radiobutton.vue'
import RadiobuttonList from './components/RadiobuttonList.vue'
import ReadonlyWithLabel from './components/ReadonlyWithLabel.vue'
import SelectWithLabel from './components/SelectWithLabel.vue'
import StreetAutocomplete from './components/StreetAutocomplete.vue'
import TextareaWithLabel from './components/TextareaWithLabel.vue'
import ToggleCheckbox from './components/ToggleCheckbox.vue'
import ZipCityWithLabel from './components/ZipCityWithLabel.vue'

import VueSelect from 'VueSelect'
import $ from 'jQuery'
import setupValidation from './utils/validation'
import registerGlobalVueFilters from './utils/vueFilters'

const MigrolVueLibrary = {
    install(Vue) {

        const globalData = new Vue({ data: { Strings: [], Settings: {}, SettingsLoaded: false, StringsLoaded: false } });

        $.get('/migrolapi/' + window.CONFIG.language + '/dictionary/MigrolVueLibraryStrings').then(function (response) {
            globalData.Strings = response;
            globalData.StringsLoaded = true;
        }, function (error) {
            console.error(error);
        });

        $.get('/migrolapi/' + window.CONFIG.language + '/settings/MigrolVueLibrarySettings').then(function (response) {
            globalData.Settings = response;
            globalData.SettingsLoaded = true;
        }, function (error) {
            console.error(error);
        });

        Object.defineProperty(Vue.prototype, '$migrolVueLibraryData', {
            get() { return globalData; }
        });

        setupValidation();
        registerGlobalVueFilters(Vue);

        //vue-select component
        VueSelect.props.components.default = () => ({
            OpenIndicator: {
                render: createElement => createElement('div', { class: 'vs__open-indicator' }),
            }
        });
        Vue.component('VueSelect', VueSelect);

        //define the components
        Vue.component('AddressEditable', AddressEditable);
        Vue.component('AddressReadonly', AddressReadonly);
        Vue.component('AGB', AGB);
        Vue.component('AjaxButton', AjaxButton);
        Vue.component('Checkbox', Checkbox);
        Vue.component('CheckboxList', CheckboxList);
        Vue.component('DatePickerWithLabel', DatePickerWithLabel);
        Vue.component('DSE', DSE);
        Vue.component('InfoIcon', InfoIcon);
        Vue.component('InputWithLabel', InputWithLabel);
        Vue.component('MigrosLoginInfo', MigrosLoginInfo);
        Vue.component('MyClimateCheckbox', MyClimateCheckbox);
        Vue.component('MyClimateDescription', MyClimateDescription);
        Vue.component('Pager', Pager);
        Vue.component('Radiobutton', Radiobutton);
        Vue.component('RadiobuttonList', RadiobuttonList);
        Vue.component('ReadonlyWithLabel', ReadonlyWithLabel);
        Vue.component('SelectWithLabel', SelectWithLabel);
        Vue.component('StreetAutocomplete', StreetAutocomplete);
        Vue.component('TextareaWithLabel', TextareaWithLabel);
        Vue.component('ToggleCheckbox', ToggleCheckbox);
        Vue.component('ZipCityWithLabel', ZipCityWithLabel);
    }
};

export default MigrolVueLibrary;

if (typeof window !== 'undefined' && window.Vue) {
    //plugin registers itself
    window.Vue.use(MigrolVueLibrary);
}
